import { AxiosResponse } from "axios";
import { QUERY_CLIENT } from "..";
import Resource from "../model/resource";
import { QueryKeys } from "./base/react-query";
import { getAxiosInstance } from "./api-utils";
const RESOURCES = "/resources";

export async function getResources(skipErrorToast = false): Promise<Resource[]> {
    const response: AxiosResponse<Resource[]> = await getAxiosInstance({ skipErrorInterceptor: skipErrorToast }).get(RESOURCES);
    return response.data;
}

export async function getResource(id: number): Promise<Resource> {
    const response: AxiosResponse<Resource> = await getAxiosInstance().get(`${RESOURCES}/${id}`);
    return response.data;
}

export async function deleteResource(resource: Resource) {
    await getAxiosInstance().delete(`${RESOURCES}/${resource.id}`);
    QUERY_CLIENT.invalidateQueries(QueryKeys.resources);
}

export async function saveResource(model: { object: Resource, initialObject: Resource }) {
    const response = await getAxiosInstance().patch(`${RESOURCES}`, model.object);
    QUERY_CLIENT.invalidateQueries(QueryKeys.resources);
    return response.data;
}

export async function updateResource(resource: Resource) {
    await getAxiosInstance().patch(`${RESOURCES}`, resource);
    QUERY_CLIENT.invalidateQueries(QueryKeys.resources);
}

export async function createResourceAndGetId(resource: Resource): Promise<number> {
    const response: AxiosResponse<Resource> = await getAxiosInstance().put(`${RESOURCES}`, resource);
    QUERY_CLIENT.invalidateQueries(QueryKeys.resources);
    return response.data.id;
}

export async function createResource(resource: Resource) {
    await getAxiosInstance().put(`${RESOURCES}`, resource);
    QUERY_CLIENT.invalidateQueries(QueryKeys.resources);
}